export default __webpack_public_path__ + "static/7c0eaecdf543bd881e55304548372cdc.jpeg";